<template>
  <b-modal size="xl" ref="modal-rateio" title="Valores de Rateio" @hidden="hiddenModal">
    <div class="row" style="margin-bottom: 22.75px;" v-if="visaoGeral">
      <div class="col-md-4"></div>
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <b-button
          class="margin-btn-5 btn-block"
          @click="incluir"
          variant="primary"
          :disabled="loading"
        >
          <i
            v-if="!loading"
            class="nav-icon flaticon2-plus"
          ></i>
          <b-spinner
            v-if="loading"
            small
            style="margin-bottom: 2px; margin-right: 3px;"
          ></b-spinner>
          Incluir
        </b-button>
      </div>
    </div>
    <div class="row" v-if="visaoGeral">
      <div class="col-md-12">
        <b-table striped hover :items="items" :fields="fields" @row-clicked="selecionarRateio">
          <template #cell(ACOES)="row">
            <b-button variant="danger" size="sm" @click="excluir(row)" class="mr-2">
              Excluir
            </b-button>
          </template>
        </b-table>
        <div
          v-if="!items.length"
          class="alert alert-dark"
          role="alert"
          style="text-align: center;"
        >
          Sem rateios cadastrados até o momento
        </div>
      </div>
    </div>
    <div class="row" v-if="detalhamento">
      <div class="col-md-8">
        <SearchBoxEmpresa
          ref="empresa"
          v-model="detalhamentoDados.ID_EMPRESA"
          @descricao="(descricao) => detalhamentoDados.EMPRESA = descricao"
        />
      </div>
      <div class="col-md-4">
        <InputValor v-model="detalhamentoDados.PORCENTAGEM" ref="porcentagem" label="Porcentagem" @change="alterouPorcentagem" />
      </div>
    </div>
    <div class="row" v-if="detalhamento">
      <div class="col-md-8">
        <SearchBoxCentroResponsabilidade
          ref="centroResponsabilidade"
          v-model="detalhamentoDados.ID_CENTRO_RESPONSABILIDADE"
          @descricao="(descricao) => detalhamentoDados.CENTRO_RESPONSABILIDADE = descricao"
        />
      </div>
      <div class="col-md-4">
        <InputValor v-model="detalhamentoDados.RATEIO_VALOR" ref="valorRateio" label="Valor Rateio" />
      </div>
    </div>
    <div class="row" v-if="detalhamento">
      <div class="col-md-8">
        <SearchBoxProjeto
          ref="projeto"
          v-model="detalhamentoDados.ID_PROJETO"
          @descricao="(descricao) => detalhamentoDados.PROJETO = descricao"
        />
      </div>
      <div class="col-md-4">
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="row" style="width: 100%;">
        <div class="col-md-4">
          <b-button
             v-if="detalhamento"
            class="margin-btn-5 btn-block"
            @click="salvar"
            variant="primary"
            :disabled="loading"
          >
            <i
              v-if="(!loading) && (indexAlteracao < 0)"
              class="nav-icon flaticon2-plus"
            ></i>
            <i
              v-if="(!loading) && (indexAlteracao >= 0)"
              class="nav-icon flaticon2-reload"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            {{ indexAlteracao >= 0 ? 'Alterar' : 'Incluir' }}
          </b-button>
          <b-button
             v-if="visaoGeral"
            class="margin-btn-5 btn-block"
            @click="salvarRegistros"
            variant="primary"
            :disabled="loading"
          >
            <i
              v-if="!loading"
              class="nav-icon flaticon2-download"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Salvar
          </b-button>
        </div>
        <div class="col-md-4">
          <DatasInclusaoAlteracao
            v-if="detalhamento"
            :dataInclusao="detalhamentoDados.DATA_INCLUSAO"
            :dataAlteracao="detalhamentoDados.DATA_ALTERACAO"
            :usuarioInclusao="detalhamentoDados.USUARIO_INCLUSAO"
            :usuarioAlteracao="detalhamentoDados.USUARIO"
          />
        </div>
        <div class="col-md-4">
          <b-button
            v-if="detalhamento"
            class="margin-btn-5 btn-block"
            @click="cancelar"
            variant="danger"
            :disabled="loading"
          >
            <i
              v-if="!loading"
              class="nav-icon flaticon2-delete"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Cancelar
          </b-button>
          <b-button
            v-if="visaoGeral"
            class="margin-btn-5 btn-block"
            @click="sair"
            variant="danger"
            :disabled="loading"
          >
            <i
              v-if="!loading"
              class="nav-icon flaticon2-delete"
            ></i>
            <b-spinner
              v-if="loading"
              small
              style="margin-bottom: 2px; margin-right: 3px;"
            ></b-spinner>
            Sair
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

import SearchBoxEmpresa from "@/../../components-spirit/SearchBox/SearchBoxEmpresa.vue";
import SearchBoxProjeto from "@/../../components-spirit/SearchBox/SearchBoxProjeto.vue";
import SearchBoxCentroResponsabilidade from "@/../../components-spirit/SearchBox/SearchBoxCentroResponsabilidade.vue";

import InputValor from "@/../../components-spirit/Inputs/InputValor.vue";

import DatasInclusaoAlteracao from "@/../../components-spirit/FormCadastro/DatasInclusaoAlteracao.vue";

import Swal from "sweetalert2";

export default {
  name: "Rateio",
  data() {
    return {
      loading: false,
      visaoGeral: true,
      detalhamento: false,
      fields: [
        {
          key: 'EMPRESA',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'PROJETO',
          label: 'Projeto',
          sortable: true,
          formatter: (value, key, item) => {
            if(item.PROJETO) {
              return item.PROJETO;
            } else {
              return 'Sem Projeto';
            }
          }
        },
        {
          key: 'CENTRO_RESPONSABILIDADE',
          label: 'Centro de Responsabilidade',
          sortable: true
        },
        {
          key: 'RATEIO_VALOR',
          label: 'Valor Rateio',
          sortable: true,
          formatter: (value, key, item) => {
            let formatter = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL'
            });
            return formatter.format(item.RATEIO_VALOR);
          }
        },
        {
          key: 'ACOES',
          label: 'Ações',
          sortable: false
        }
      ],
      items: [],
      detalhamentoDados: {
        ID_FLUXO_DE_CAIXA_RATEIO: "",
        ID_FLUXO_DE_CAIXA: "",
        ID_EMPRESA: "0",
        EMPRESA: "",
        ID_PROJETO: "0",
        PROJETO: "",
        ID_CENTRO_RESPONSABILIDADE: "0",
        CENTRO_RESPONSABILIDADE: "",
        PORCENTAGEM: 100,
        RATEIO_VALOR: "",
        DATA_INCLUSAO: "",
        DATA_ALTERACAO: "",
        USUARIO_INCLUSAO: "",
        USUARIO: ""
      },
      indexAlteracao: -1
    }
  },
  components: {
    SearchBoxEmpresa,
    SearchBoxProjeto,
    SearchBoxCentroResponsabilidade,
    InputValor,
    DatasInclusaoAlteracao
  },
  props: ["idFluxoDeCaixa", "valor"],
  async mounted() {

  },
  methods: {
    ...mapActions([
      "getRateios",
      "updateRateios"
    ]),
    toggleForm() {
      this.visaoGeral = !this.visaoGeral;
      this.detalhamento = !this.detalhamento;
    },
    hiddenModal() {
      this.visaoGeral = true;
      this.detalhamento = false;
      this.items = [];
      this.$emit('saiuModal');
    },
    valorDisponivel() {
      let valor = this.valor;

      this.items.forEach((item, index) => {
        if(index !== this.indexAlteracao) {
          valor -= item.RATEIO_VALOR;
        }
      });

      return valor;
    },
    incluir() {
      let valor = this.valorDisponivel();

      if(valor) {
        this.detalhamentoDados.PORCENTAGEM = ((valor / this.valor) * 100).toFixed(2);
        this.detalhamentoDados.RATEIO_VALOR = valor;
        this.toggleForm();
      } else {
        Swal.fire({
          title: "Aviso",
          text: "O valor já foi totalmente rateado.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      }
    },
    excluir(row) {
      this.items.splice(row.index, 1);
    },
    limparForm() {
      this.detalhamentoDados.ID_FLUXO_DE_CAIXA_RATEIO = "";
      this.$refs.empresa.apagar();
      this.$refs.centroResponsabilidade.apagar();
      this.$refs.projeto.apagar();
      this.detalhamentoDados.ID_EMPRESA = "0";
      this.detalhamentoDados.ID_PROJETO = "0";
      this.detalhamentoDados.ID_CENTRO_RESPONSABILIDADE = "0";
      this.detalhamentoDados.EMPRESA = "";
      this.detalhamentoDados.PROJETO = "";
      this.detalhamentoDados.CENTRO_RESPONSABILIDADE = "";
      this.detalhamentoDados.PORCENTAGEM = 100;
      if(this.valor) {
        this.detalhamentoDados.RATEIO_VALOR = this.valor;
      } else {
        this.detalhamentoDados.RATEIO_VALOR = "";
      }
      this.indexAlteracao = -1;
    },
    cancelar() {
      this.toggleForm();
      this.limparForm();
    },
    alterouPorcentagem() {
      if(this.valor) {
        this.detalhamentoDados.RATEIO_VALOR = ((this.valor/100) * this.detalhamentoDados.PORCENTAGEM).toFixed(2);
      }
    },
    async show() {
      this.$refs["modal-rateio"].show();

      if(this.idFluxoDeCaixa) {
        this.detalhamentoDados.ID_FLUXO_DE_CAIXA = this.idFluxoDeCaixa;
        this.loading = true;
        this.items = await this.getRateios(this.idFluxoDeCaixa);
        this.loading = false;
      }
      
      if(this.valor) {
        this.detalhamentoDados.RATEIO_VALOR = this.valor;
      }
    },
    sair() {
      this.$refs["modal-rateio"].hide();
    },
    validarObjForm(obj) {
      let retorno = true;

      let valor = this.valorDisponivel();

      if((!obj.ID_EMPRESA) || (obj.ID_EMPRESA == '0')) {
        Swal.fire({
          title: "Aviso",
          text: "A empresa é um campo obrigatório.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });

        retorno = false;
      } else if((!obj.ID_CENTRO_RESPONSABILIDADE) || (obj.ID_CENTRO_RESPONSABILIDADE == '0')) {
        Swal.fire({
          title: "Aviso",
          text: "O centro de responsabilidade é um campo obrigatório.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });

        retorno = false;
      } else if((!obj.RATEIO_VALOR) || (obj.RATEIO_VALOR == '0')) {
        Swal.fire({
          title: "Aviso",
          text: "O valor é um campo obrigatório.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });

        retorno = false;
      } else if(parseFloat(obj.RATEIO_VALOR) > parseFloat(valor)) {
        Swal.fire({
          title: "Aviso",
          text: "O valor excede o total disponível.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });

        retorno = false;
      }

      return retorno;
    },
    selecionarRateio(record, index) {
      this.toggleForm();
      this.loading = true;

      setTimeout(() => {
        if(record.ID_FLUXO_DE_CAIXA_RATEIO) {
          this.detalhamentoDados.ID_FLUXO_DE_CAIXA_RATEIO = record.ID_FLUXO_DE_CAIXA_RATEIO;
        } else {
          this.detalhamentoDados.ID_FLUXO_DE_CAIXA_RATEIO = "";
        }
        if((record.ID_EMPRESA) && (record.ID_EMPRESA !== "0")) {
          this.detalhamentoDados.ID_EMPRESA = record.ID_EMPRESA;
          this.detalhamentoDados.EMPRESA = record.EMPRESA;
          this.$refs.empresa.selecionar({
            ID: record.ID_EMPRESA,
            DESCRICAO: record.EMPRESA
          });
        } else {
          this.detalhamentoDados.ID_EMPRESA = "0";
          this.detalhamentoDados.EMPRESA = "";
        }
        if((record.ID_CENTRO_RESPONSABILIDADE) && (record.ID_CENTRO_RESPONSABILIDADE !== "0")) {
          this.detalhamentoDados.ID_CENTRO_RESPONSABILIDADE = record.ID_CENTRO_RESPONSABILIDADE;
          this.detalhamentoDados.CENTRO_RESPONSABILIDADE = record.CENTRO_RESPONSABILIDADE;
          this.$refs.centroResponsabilidade.selecionar({
            ID: record.ID_CENTRO_RESPONSABILIDADE,
            DESCRICAO: record.CENTRO_RESPONSABILIDADE
          });
        } else {
          this.detalhamentoDados.ID_CENTRO_RESPONSABILIDADE = "0";
          this.detalhamentoDados.CENTRO_RESPONSABILIDADE = "";
        }
        if((record.ID_PROJETO) && (record.ID_PROJETO !== "0")) {
          this.detalhamentoDados.ID_PROJETO = record.ID_PROJETO;
          this.detalhamentoDados.PROJETO = record.PROJETO;
          this.$refs.projeto.selecionar({
            ID: record.ID_PROJETO,
            DESCRICAO: record.PROJETO
          });
        } else {
          this.detalhamentoDados.ID_PROJETO = "0";
          this.detalhamentoDados.PROJETO = "";
        }
        if(record.RATEIO_VALOR) {
          this.detalhamentoDados.RATEIO_VALOR = record.RATEIO_VALOR;
        } else {
          this.detalhamentoDados.RATEIO_VALOR = "";
        }

        this.detalhamentoDados.PORCENTAGEM = ((this.detalhamentoDados.RATEIO_VALOR / this.valor) * 100).toFixed(2);

        this.indexAlteracao = index;
        this.loading = false;
      }, 1000);
    },
    salvar() {
      let obj = {
        ID_FLUXO_DE_CAIXA_RATEIO: this.detalhamentoDados.ID_FLUXO_DE_CAIXA_RATEIO,
        ID_FLUXO_DE_CAIXA: this.detalhamentoDados.ID_FLUXO_DE_CAIXA,
        ID_EMPRESA: this.detalhamentoDados.ID_EMPRESA,
        EMPRESA: this.detalhamentoDados.EMPRESA,
        ID_CENTRO_RESPONSABILIDADE: this.detalhamentoDados.ID_CENTRO_RESPONSABILIDADE,
        CENTRO_RESPONSABILIDADE: this.detalhamentoDados.CENTRO_RESPONSABILIDADE,
        ID_PROJETO: this.detalhamentoDados.ID_PROJETO,
        PROJETO: this.detalhamentoDados.PROJETO,
        RATEIO_VALOR: parseFloat(this.detalhamentoDados.RATEIO_VALOR).toFixed(2)
      };

      if(this.validarObjForm(obj)) {
        if(this.indexAlteracao >= 0) {
          this.items.splice(this.indexAlteracao, 1);
        }
        this.items.push(obj);
        this.cancelar();
      }
    },
    async salvarRegistros() {
      let valor = this.valorDisponivel();

      if((valor == 0) || (valor == this.valor)) {
        this.loading = true;
        await this.updateRateios({idFluxoDeCaixa: this.idFluxoDeCaixa, items: this.items});
        this.loading = false;

        Swal.fire({
          title: "Sucesso",
          text: "As informações de rateio foram salvas.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false
        });

        this.sair();
      } else {
        Swal.fire({
          title: "Aviso",
          text: "Você ainda não distribuiu todo o valor entre os rateios.",
          icon: "warning",
          timer: 3000,
          showConfirmButton: false
        });
      }
    }
  }
}
</script>

<style lang="scss">
  .b-table tr {
    cursor: pointer;
  }
</style>